__turbopack_context__.v({
  "groupContainer": "SearchForm-module-scss-module__nlzVFW__groupContainer",
  "inputField": "SearchForm-module-scss-module__nlzVFW__inputField",
  "inputFieldContainer": "SearchForm-module-scss-module__nlzVFW__inputFieldContainer",
  "showBackground": "SearchForm-module-scss-module__nlzVFW__showBackground",
  "submitFieldContainer ": "SearchForm-module-scss-module__nlzVFW__submitFieldContainer ",
  "withBorder": "SearchForm-module-scss-module__nlzVFW__withBorder",
});
